import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const deactivateUser = async (userId: string) => {
  await api.post(`/users/${userId}/deactivate/`)
  queryClient.invalidateQueries([BASE_USERS_QUERY_KEY])
}
